import { setTranslations, setLocale, setHandleMissingTranslation } from 'react-i18nify';

const initTranslations = ({ resources = {}, lng = 'en', fallbackLng = 'en' } = {}) => {
  const locale = lng || fallbackLng;

  setHandleMissingTranslation((key, replacements) => {
    if (replacements.fallbackMessage) {
      return replacements.fallbackMessage;
    }

    return key.split('.').pop();
  });

  setTranslations({
    [locale]: resources,
  });

  setLocale(locale);
};

export default initTranslations;
